// Zod's default object-schema fast path probes `Function("")`. Browsers report
// that caught probe as a CSP violation even when Zod falls back safely. Seed the
// shared Zod v4 configuration before any schema module is evaluated so the
// production bundle never attempts dynamic code generation.
const zodGlobal = globalThis as typeof globalThis & {
  __zod_globalConfig?: { jitless?: boolean };
};

zodGlobal.__zod_globalConfig ??= {};
zodGlobal.__zod_globalConfig.jitless = true;
